export function maskEmail(email: string) {
  if (email.indexOf('@') === -1) return email;
  
  const [local, domain] = email.split('@');
  if (local.length < 4) return email;
  
  const maskedLocal = `${local[0]}${'*'.repeat(local.length - 2)}${local[local.length - 1]}`;
  return `${maskedLocal}@${domain}`;
}
